import { Box } from '@components/ui/atoms/Box';
import { Flex } from '@components/ui/atoms/Flex';
import { Heading } from '@components/ui/atoms/Heading';
import { Image } from '@components/ui/atoms/Image';
import React, { useEffect } from 'react';

type Props = {
  children: React.ReactNode;
  bgImage: string;
  logo?: string;
};

export const ErrorLayout: React.FC<Props> = ({ children, bgImage, logo }) => {
  useEffect(() => {
    document.body.dataset.errorPageActive = 'true';

    return () => {
      delete document.body.dataset.errorPageActive;
    };
  }, []);

  return (
    <Box
      as="main"
      position="fixed"
      inset={0}
      w="100vw"
      h="100vh"
      overflow="hidden"
      zIndex={10000}
      css={{
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          zIndex: 0,
        },
      }}
    >
      {logo && (
        <Flex alignItems="center" gap="8px" position="absolute" top="5%" left="10%" zIndex={1}>
          <Image src={logo} width="28px" height="24px" alt="Logo" />
          <Heading fontSize="13px" fontWeight="700" color="title.dark">
            Bhutan Payments
          </Heading>
        </Flex>
      )}

      <Box position="relative" zIndex={1} h="100vh">
        {children}
      </Box>

      {/* <Box position="absolute" bottom="5%" right="10%" zIndex={1}>
        <Heading fontSize="xs" fontWeight="bold" color="body.dark" opacity={0.5}>
          {errorCode}
        </Heading>
      </Box> */}
    </Box>
  );
};

ErrorLayout.displayName = 'ErrorLayout';
